import {
  decomposePitch,
  getTuningOffset
} from 'player/src/hooks/use-song-key/utils'
import createPersistedState from 'use-persisted-state'
import { useMemo } from 'react'
import { OperationSettings } from '../../../../../hooks/player/use-persisted-channel-settings'
import { TaskOperations } from '../../../../../types'
import { findOperation } from '../../../../../lib/operations'

export const usePitchInitialState = ({
  mainOperations,
  preset
}: {
  mainOperations: TaskOperations[]
  preset?: OperationSettings
}): number | undefined => {
  // TODO Remove the usage of this storage
  // To remove this hook, we need to migrate the tuning to the persisted
  // settings. The first step is done: the tuning is been saved there. The
  // second step is the removal, but we need to wait for the majority of the
  // users to have the persisted settings in place before that.
  const useEstimatedTuningState = createPersistedState<number | null>(
    `tuning-${mainOperations[0]?.id}`
  )

  const originalTuning = useMemo(() => {
    const beatschords = findOperation(mainOperations, 'beatschords', {
      status: 'COMPLETED'
    })
    return (beatschords?.result?.estimatedTuning as number | undefined) || null
  }, [mainOperations])
  const [estimatedTuning] = useEstimatedTuningState(originalTuning)

  return useMemo(() => {
    let pitchShiftCents = preset?.general?.pitchShiftCents

    if (pitchShiftCents) {
      const { basePitch } = decomposePitch(pitchShiftCents, originalTuning || 0)
      const tuningOffset = getTuningOffset(estimatedTuning, originalTuning || 0)
      pitchShiftCents = basePitch + tuningOffset
    }

    return pitchShiftCents
  }, [estimatedTuning, originalTuning, preset?.general?.pitchShiftCents])
}
